import DescriptionStep from './DescriptionStep.tsx';
import type { DescriptionStepInput } from './DescriptionStep.validation.ts';
import type { StepConfig } from '../../../../technical/wizard/StepConfig.ts';

export const config = ({
  namePlaceholder,
  descriptionPlaceholder,
  goToNextStep,
}: {
  namePlaceholder?: string;
  descriptionPlaceholder?: string;
  goToNextStep: () => void;
}): StepConfig<DescriptionStepInput> => ({
  label: 'Description',
  element: (
    <DescriptionStep
      goToNextStep={goToNextStep}
      namePlaceholder={namePlaceholder}
      descriptionPlaceholder={descriptionPlaceholder}
    />
  ),
  fields: ['name', 'description', 'useUnderlying'],
});
